import { render, staticRenderFns } from "./SubmissionCreateModal.vue?vue&type=template&id=2dcf5ae6&scoped=true"
import script from "./SubmissionCreateModal.vue?vue&type=script&lang=js"
export * from "./SubmissionCreateModal.vue?vue&type=script&lang=js"
import style0 from "./SubmissionCreateModal.vue?vue&type=style&index=0&id=2dcf5ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcf5ae6",
  null
  
)

export default component.exports